import React from 'react';
import {
  Page, Section, SectionTitleUnderlined, SkillPills, ExperienceList,
  LineList, ContactRow
} from './_shared';

/**
 * "Modern" template (key: professional-clean).
 *
 * The default ATS-friendly resume. Single column, neutral typography, one
 * subtle accent color (deep slate). Designed to scan well in both ATS systems
 * and human review for tech, business, and general professional roles.
 */

const ACCENT = '#1f2937';      // slate-800 — neutral, professional
const PILL_BG = '#f1f5f9';     // slate-100

const ProfessionalClean = ({ data }) => {
  const fontFamily = "'Inter', 'Helvetica Neue', Arial, sans-serif";
  return (
    <Page accent={ACCENT} fontFamily={fontFamily}>
      <header style={{ marginBottom: '0.65rem' }}>
        <h1 style={{
          fontSize: '26pt',
          fontWeight: 700,
          margin: 0,
          letterSpacing: '-0.01em',
          color: '#0f172a'
        }}>
          {data.fullName}
        </h1>
        {data.jobTitle && (
          <div style={{
            fontSize: '11pt',
            color: ACCENT,
            marginTop: '2px',
            fontWeight: 500
          }}>
            {data.jobTitle}
          </div>
        )}
        <ContactRow data={data} style={{ marginTop: '6px' }} />
      </header>

      <div style={{ height: '1.5px', background: ACCENT, marginBottom: '0.7rem' }} />

      {data.summary && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Summary</SectionTitleUnderlined>
          <p style={{ margin: 0 }}>{data.summary}</p>
        </Section>
      )}

      {data.skills && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Skills</SectionTitleUnderlined>
          <SkillPills skills={data.skills} accent={ACCENT} background={PILL_BG} />
        </Section>
      )}

      {data.experience && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Experience</SectionTitleUnderlined>
          <ExperienceList text={data.experience} accent={ACCENT} />
        </Section>
      )}

      {data.education && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Education</SectionTitleUnderlined>
          <LineList text={data.education} />
        </Section>
      )}

      {data.certifications && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Certifications</SectionTitleUnderlined>
          <LineList text={data.certifications} />
        </Section>
      )}

      {data.languages && (
        <Section>
          <SectionTitleUnderlined accent={ACCENT}>Languages</SectionTitleUnderlined>
          <LineList text={data.languages} />
        </Section>
      )}
    </Page>
  );
};

export default ProfessionalClean;
